@if (messages.length && messagesVisible) {
    <div
        class="flex h-10 w-screen flex-row items-center"
        [style.background-color]="messages[currentIndex].backgroundColor"
        [style.color]="messages[currentIndex].textColor"
    >
        <div class="flex-grow text-center">
            @for (message of messages; let index=$index; track message.content){
                @if (index === currentIndex) {
                    <div [@slideInLeft]  class="px-5 h-10 overflow-y-auto py-1 text-lg">
                        {{ messages[currentIndex].content }}
                        @if (message.url !== undefined) {
                            <a class="px-3 inline-block text-inherit"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Meer weten"
                                [href]="messages[currentIndex].url"
                                i18n-title="@@link.more"
                            >
                                <fa-icon [icon]="faArrowUpRightFromSquare" />
                            </a>
                        }
                    </div>
                }
            }
        </div>
        @if (messages.length > 1) {
            <button
                title="Vorige"
                i18n-title="@@button.previous"
                type="button"
                class="button-icon px-2"
                (click)="showPrevious()"
                (keypress)="showPrevious()"
            >
                <fa-icon [icon]="previousIcon"></fa-icon>
            </button>
            <button
                title="Volgende"
                i18n-title="@@button.next"
                type="button"
                class="button-icon px-2"
                (click)="showNext()"
                (keypress)="showNext()"
            >
                <fa-icon [icon]="nextIcon"></fa-icon>
            </button>
        }
        <button
            title="Sluit"
            i18n-title="@@button.close"
            type="button"
            class="button-icon pl-2 pr-5"
            (click)="hideMessages()"
            (keypress)="hideMessages()"
        >
            <fa-icon [icon]="faXmark"></fa-icon>
        </button>
    </div>
}
